import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { ContactService } from 'src/app/private/services/contact.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-contact',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './create-contact.component.html',
  styleUrl: './create-contact.component.scss'
})
export class CreateContactComponent {
  // contactForm
  @ViewChild('contactForm') contactForm: any;

  createFieldFormValue: any = {};
  fieldValues: any = {};
  previousContactData: any = {};
  today: Date = new Date();

  isFixedColumn: boolean = true;
  isSubmitted: boolean = false;
  @Input() allContactFields: any = [];
  @Input() users: any = [];
  @Input() editContactData: any = {};
  @Output() reload = new EventEmitter<any>();
  @Input() formAction: any = 'Add';
  @Input() allCourses: any = [];
  @Input() academicYears: any = [];
  @Input() batches: any = [];
  @Input() courses: any = [];
  @Input() departments: any = [];
  isAdmin: boolean = true;
  isLoading: boolean = false;

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  designationOptions: any[] = [
    { label: 'Faculty', value: 'Faculty' },
    { label: 'Student', value: 'Student' },
    { label: 'Staff', value: 'Staff' },
    { label: 'Administrator', value: 'Administrator' },
    { label: 'Parent', value: 'Parent' },
    { label: 'Guardian', value: 'Guardian' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Visitor', value: 'Visitor' },
    { label: 'Other', value: 'Other' }
  ];

  constructor(
    private api: ContactService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.isSubmitted = false;

    if (changes['users'] && changes['users'].currentValue != changes['users'].previousValue) {
      this.users = this.users.map((user: any) => {
        return {
          label: user.fname + " " + user.lname,
          value: user?.user_id
        }
      });
    }

    if (changes['editContactData'] && changes['editContactData'].currentValue != changes['editContactData'].previousValue) {
      this.createFieldFormValue = this.editContactData;
      this.createFieldFormValue.contact_phone = this.createFieldFormValue.phone;
      this.fieldValues = this.editContactData.dynamic_fields || {};
      this.previousContactData = JSON.parse(JSON.stringify(this.editContactData));
    }

    // Initialize organization_id, campus_id, and user_id if not set
    if (!this.createFieldFormValue.organization_id) {
      this.createFieldFormValue.organization_id = this.localStorage.getOrganizationId();
    }
    if (!this.createFieldFormValue.campus_id) {
      this.createFieldFormValue.campus_id = this.localStorage.getCampusId();
    }
    if (!this.createFieldFormValue.user_id) {
      this.createFieldFormValue.user_id = this.localStorage.getUserId();
    }

    console.log("users", this.users);
  }

  @Output() closeDialog = new EventEmitter<any>();

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit(isValid: any) {
    this.isSubmitted = true;
    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    if (this.allContactFields && this.allContactFields.length > 0) {
      for (let field of this.allContactFields) {
        if (field.required && !this.fieldValues[field.field_name]) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `${field.field_label} is required` });
          return;
        }
      }
    }

    if (isValid) {
      if (this.formAction == 'Add') {
        this.isSubmitted = true;
        this.isLoading = true;
        this.createFieldFormValue.organization_id = this.localStorage.getOrganizationId();
        this.createFieldFormValue.campus_id = this.localStorage.getCampusId();
        this.createFieldFormValue.user_id = this.localStorage.getUserId();
        this.createFieldFormValue.dynamic_fields = this.fieldValues;
        this.createFieldFormValue.phone = this.createFieldFormValue.contact_phone;

        this.api.createContact(this.createFieldFormValue).subscribe({
          next: (c) => {
            this.isLoading = false;
            this.reload.emit();
            this.createFieldFormValue = {};
            this.fieldValues = {};
            this.isSubmitted = false;
            this.previousContactData = {};

            // reset the form
            this.contactForm.resetForm();

            this.closeDialog.emit();
          },
          error: (e) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          },
          complete: () => { },
        });
      } else if (this.formAction == 'Update') {
        this.isSubmitted = true;
        this.isLoading = true;
        this.createFieldFormValue.dynamic_fields = this.fieldValues;
        this.createFieldFormValue.phone = this.createFieldFormValue.contact_phone;

        this.createFieldFormValue.old_contact_data = this.previousContactData;

        this.api.updateContact(this.createFieldFormValue).subscribe({
          next: (c) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Updated Successfully' });
            this.createFieldFormValue = {};
            this.fieldValues = {};
            this.previousContactData = {};
            this.isSubmitted = false;
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (e) => {
            this.isLoading = false;
            this.isSubmitted = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
          },
          complete: () => { },
        });
      }
    }
  }
}
